import { useActiveChannel } from "../hooks/channels";
import { useAppStore } from "../store/app";
import { haptics } from "../lib/telegram";

/**
 * Top bar: active-channel title (tap → channel switcher) and, only when the
 * active channel is one the user administers, a shield that opens the admin hub.
 * The shield is the always-one-tap admin entry point — it vanishes the moment you
 * switch to a channel you only follow.
 */
export function Header() {
  const { channel } = useActiveChannel();
  const setSwitcherOpen = useAppStore((s) => s.setChannelSwitcherOpen);
  const setAdminOpen = useAppStore((s) => s.setAdminHubOpen);

  return (
    <header
      className="sticky top-0 z-30 flex items-center gap-2 border-b border-tg-separator bg-tg-bg-header px-4 py-3"
      style={{ paddingTop: "max(12px, var(--safe-top))" }}
    >
      <button
        type="button"
        onClick={() => {
          haptics.select();
          setSwitcherOpen(true);
        }}
        className="flex min-w-0 flex-1 items-center gap-1 text-left active:opacity-70"
      >
        <span className="truncate text-base font-semibold text-tg-text">
          {channel?.title ?? "Channel Library"}
        </span>
        <span className="text-tg-hint">▾</span>
      </button>

      {channel?.is_admin && (
        <button
          type="button"
          aria-label="Admin panel"
          onClick={() => {
            haptics.impact("light");
            setAdminOpen(true);
          }}
          className="shrink-0 rounded-full bg-tg-bg-secondary px-2.5 py-1.5 text-sm active:scale-95"
        >
          🛡
        </button>
      )}
    </header>
  );
}
